import { isColHidden } from './index.js';
import { logger } from './logger.js';

// src/utils/validateOptions.ts
function traverseColumnsWidth(cols) {
  if (!cols || !cols.length) return false;
  return cols.every((col) => {
    if (col.children && col.children.length) {
      return traverseColumnsWidth(col.children);
    }
    return !!col.width || isColHidden(col);
  });
}
function validateColumnsFlex(cols) {
  if (traverseColumnsWidth(cols) && true) {
    logger.errorOnce("[use-antd-resizable-header] \u8BF7\u4E0D\u8981\u5728\u6240\u6709\u5217\u4E0A\u6DFB\u52A0 `width` \u5C5E\u6027\uFF0C\u8FD9\u5C06\u5BFC\u81F4\u8868\u683C\u65E0\u6CD5\u81EA\u9002\u5E94");
    return false;
  }
}
function traverseColumnsDataIndex(cols, dataIndexMap = /* @__PURE__ */ new Map()) {
  if (!cols || !cols.length) return false;
  return cols.every((col) => {
    if (col.children && col.children.length) {
      return traverseColumnsDataIndex(col.children, dataIndexMap);
    }
    if (col.dataIndex) {
      if (dataIndexMap.has(col.dataIndex)) {
        {
          logger.errorOnce(
            `[use-antd-resizable-header] dataIndex \u91CD\u590D: ${col.dataIndex}\uFF0C\u8BF7\u786E\u4FDD\u6BCF\u4E2A\u5217\u7684 [dataIndex] \u552F\u4E00`
          );
        }
        return false;
      }
      dataIndexMap.set(col.dataIndex, true);
    }
    return true;
  });
}
function validateColumnsDataIndex(cols) {
  traverseColumnsDataIndex(cols, /* @__PURE__ */ new Map());
}
function validateColumns(cols) {
  validateColumnsFlex(cols);
  validateColumnsDataIndex(cols);
}

export { validateColumns };
